export default "__VITE_PUBLIC_ASSET__f277955f__"